export default __webpack_public_path__ + "static/media/darkweapons.ed476679.png";